import React from "react";
import Loader from 'react-loader-spinner'
import { checkTranslation, imageAddress, translate } from "../../utils/useful";
import HttpServices from "../../utils/Http.services";
import FixedView from "../FixedView";
import HubConditionBuilder from "./HubConditionBuilder";


class HubsAndGroupsInput extends React.Component {

  state = {

    selecteds: { groups: {}, hubs: {} },
    groupsTempData: [],
    image: '',
    tab: 'hubs'

  }


  componentDidMount() {


    this.init()

    setTimeout(() => {
      this.fetchUsers()
      this.fetchGroups()
    }, 10);


    // this.setState({ selecteds: {} }, () => {
    // let types = ['hubs', 'groups']
    // let selecteds = {}

    // types.forEach(type => {
    //   let parentType = type
    //   if (Array.isArray(this.props[parentType])) {
    //     this.props[parentType].forEach(element => {
    //       selecteds[element._id] = { ...element }
    //       selecteds[element._id].removed = false
    //       selecteds[element._id].init = true
    //       selecteds[element._id].type = type

    //       if (!this.props.currentRole) {
    //         selecteds[element._id].disabled = true
    //       }
    //     });
    //   }
    // });

    // this.setState({ selecteds })

    // })

  }


  componentDidUpdate(prevProps) {

    if (prevProps.data != this.props.data && prevProps.data == null) {
      this.init()
    }

  }

  init = () => {

    let selecteds = { groups: {}, hubs: {} }
    let data = this.props.data

    if (this.props.data && (Array.isArray(data.groups) || Array.isArray(data.hubs))) {

    } else {

      let info = this.props.header?.information

      if (info?.default) {
        data = info.default
      }

    }
    // console.log(this.props.data)
    if (data) {
      if (Array.isArray(data.groups)) {

        data.groups.forEach(group => {
          if (group.group) {
            selecteds.groups[group.group?._id ?? group.group] = group.group
          } else {
            selecteds.groups[group?._id ?? group] = group
          }
        });

      }

      if (Array.isArray(data.hubs)) {

        data.hubs.forEach(hub => {
          if (hub.hub) {
            selecteds.hubs[hub.hub?._id ?? hub.hub] = hub.hub
          } else {
            selecteds.hubs[hub?._id ?? hub] = hub
          }
        });

      }

      if (data.condition) {

        selecteds.condition = data.condition

      }

    }

    this.setState({ selecteds })

  }


  fetchUsers = () => {

    this.setState({ isLoadingUsers: true })

    let appletHub = this.props.variables?.appletHub
    appletHub = appletHub?._id ?? appletHub
    let selecteds = this.state.selecteds

    HttpServices.request('searchHubWithRelation', { appletHub }, (fetchResult, fetchError, fetchStatus) => {

      // console.log(fetchResult, fetchError)

      this.setState({ isLoadingUsers: false })

      if (fetchError) {
        return
      }

      if (selecteds?.hubs) {
        for (const [key, hub] of Object.entries(selecteds.hubs)) {
          if (typeof hub != 'object') {

            fetchResult.info.forEach(user => {
              if (hub == user._id) {
                selecteds.hubs[hub] = user
              }
            })
          }
        }
      }

      this.setState({ hubs: fetchResult.info, rawHubs: fetchResult.info, selecteds })

    })
  }



  fetchGroups = () => {

    this.setState({ isLoadingGroups: true })

    let body = { applet: this.props.variables?.appletId, appletHub: this.props.variables?.appletHub, hub: this.props.variables?.appletHub, targetId: this.props.variables?.appletHub }

    HttpServices.request('getConnectionGroups', body, (fetchResult, fetchError, fetchStatus) => {
      this.setState({ isLoadingGroups: false })

      if (fetchError) {
        return
      }

      let selecteds = this.state.selecteds

      if (selecteds?.groups) {
        for (const [key, hub] of Object.entries(selecteds.groups)) {
          if (typeof hub != 'object') {
            fetchResult.info.forEach(user => {
              if (hub == user._id) {
                selecteds.groups[hub] = user
              }
            })
          }
        }
      }


      this.setState({ groups: fetchResult.info, rawGroups: fetchResult.info, selecteds })

    })
  }


  // onDone = () => {
  //   let selecteds = this.state.selecteds
  //   let final = []

  //   Object.values(selecteds).forEach(element => {
  //     final.push(element)
  //   })

  //   this.props.onDone(final, 'hub', () => {
  //   })

  // }


  setTab = (tab) => {
    this.setState({ tab })
  }


  changeSelect = (prop, type) => {

    // console.log(this.state.selecteds[type])
    // console.log(prop)
    let selecteds = this.state.selecteds ?? {}

    if (type == 'condition') {

      delete selecteds.condition

    } else {

      if (!this.state.selecteds[type][prop._id]?.disabled) {
        if (!selecteds[type]) {
          selecteds[type] = {}
        }
        if (!selecteds[type][prop._id] || selecteds[type][prop._id].removed) {
          // selecteds[type][prop._id] = { _id: prop._id, name: prop.name, hubs: prop.hubs, groups: prop.groups, fullname: prop.fullname, image: prop.image, type: type, username: prop.username }
          selecteds[type][prop._id] = prop
          // selecteds[type][prop._id].type = type

        } else {
          delete selecteds[type][prop._id]
        }

        console.log(selecteds)


      }
    }

    this.setState({ selecteds }, () => this.changeValue())

  }


  changeValue() {
    let selecteds = this.state.selecteds
    let output = {}
    let info = this.props.header?.information

    let hubs = Object.values(selecteds.hubs)
    let groups = Object.values(selecteds.groups)
    let condition = selecteds.condition

    if (hubs.length > 0) {

      output.hubs = []

      hubs.forEach(element => {
        if (info.permissions) {
          output.hubs.push({ hub: (typeof element == 'object' ? element._id : element), permissions: '*' })
        } else {
          output.hubs.push(typeof element == 'object' ? element._id : element)
        }
      })
    }

    if (groups.length > 0) {

      output.groups = []

      groups.forEach(element => {
        if (info.permissions) {
          output.groups.push({ group: (typeof element == 'object' ? element._id : element), permissions: '*' })
        } else {
          output.groups.push(typeof element == 'object' ? element._id : element)
        }
      })
    }

    if (condition) {
      output.condition = condition
    }


    // console.log(output)
    this.props.changeValue(this.props.header.key, output, this.props.extra)
  }
  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }


  renderGroupOptions(fullData, options, level) {

    return (
      <div className="w-100 ">

        {Array.isArray(options) && (
          options.map((prop, index) => {
            let selected = false

            let childrenData = fullData.filter((a) => {
              let id = a.parent
              if (typeof id == 'object') {
                id = id?._id
              }
              return id == prop._id
            })

            selected = (this.state.selecteds.groups[prop._id] && this.state.selecteds.groups[prop._id].removed != true)
            let disabled = this.state.selecteds.groups[prop._id]?.disabled

            return (
              <div >
                <div key={index} onClick={() => this.changeSelect(prop, 'groups')} className="flexcb backHover pld-4 prd-4 pb-1 pt-1 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>

                  <div className="mb-1 mt-1 w-100 text-start flexcb" style={{ paddingLeft: level == null ? 0 : ((level ?? 0) * 10), paddingRight: 0, }}>
                    <p className="text-semibold text-normal">{prop.name}</p>

                    {prop.licensed && (
                      <div className='flexc br-20 ' style={{}}>
                        <img src="/assets/icons/applets/general/diamond-award.png" height={20} alt="" />
                      </div>
                    )}
                  </div>

                </div>

                {Array.isArray(childrenData) && childrenData.length > 0 && (
                  <div >
                    {this.renderGroupOptions(fullData, childrenData, (level + 1))}
                  </div>
                )}

              </div>
            )
          })
        )}




      </div>
    )
  }


  searchGroups = async (value) => {

    this.setState({ groupSearchtitle: value })


    if (value == "") {
      // console.log(this.state.groupsTempData)

      await this.setState({ groups: this.state.groupsTempData }, () => {
        this.setState({ groupsTempData: [] })
      })

    } else {
      if (this.state.groupsTempData.length == 0) {
        await this.setState({ groupsTempData: [...this.state.groups] })
      }
      let values = []
      console.log(this.state.groupsTempData)
      this.state.groupsTempData.forEach(element => {
        if (String(element.name).toLowerCase().includes(String(value).toLowerCase())) {
          values.push(element)
        }
      })


      this.addParents(this.state.groupsTempData, values)

      console.log(values)
      this.setState({ groups: values }, () => {
      })

    }
  }



  addParents = (allData, values) => {

    values.forEach(value => {
      if (value.parent) {

        this.findParents(allData, values, value.parent)

      }
    });
  }

  findParents = (allData, values, parentId) => {

    let parents = allData.filter((a) => {
      let id = parentId
      if (typeof id == 'object') {
        id = id?._id
      }
      return a._id == id
    })

    if (parents[0]) {
      let found = false

      for (let i = 0; i < values.length; i++) {
        const element = values[i];
        if (element._id == parents[0]._id) {
          found = true
        }
      }
      if (!found) {
        values.push(parents[0])
      }

      if (parents[0].parent) {
        this.findParents(allData, values, parents[0].parent)

      }
    }
  }


  toggleOpen = (open) => {

    this.fixedView.showView()

  }

  changeConditionValue = (key, value, extra) => {

    let selecteds = this.state.selecteds

    selecteds.condition = value

    this.setState({ selecteds }, () => {
      this.changeValue()
    })
    // console.log(value)

  }




  render() {

    let parentGroupsData = this.state.groups
    if (Array.isArray(parentGroupsData)) {
      parentGroupsData = parentGroupsData.filter((a) => a.parent == null)
    }

    let hubsArray = Object.values(this.state.selecteds.hubs)
    let groupsArray = Object.values(this.state.selecteds.groups)
    let condition = this.state.selecteds?.condition

    let info = this.props.header?.information

    return (
      <div className="w-100 h-100" style={{ position: 'relative', }} ref={el => this.currentNode = el}>

        <div className="w-100" onClick={() => this.toggleOpen(true)} >

          {(hubsArray?.length == 0 && groupsArray?.length == 0 && !condition) && (
            <p className=" placeholder ">{info.placeholder ? checkTranslation(info.placeholder) : translate("Add hubs, people, and groups to give them access")}</p>
          )}

          {/* {hubsArray.length > 0 && (
            <div className="flexc flex-wrap">
              {hubsArray.map((hub, index) => {
                return (
                  <div className="pld-2 prd-4 py-1 br-20 mrd-2 flexc mb-1" style={{ backgroundColor: '#00000012' }}>

                    <button onClick={(e) => { e.stopPropagation(); this.changeSelect(hub, 'hubs') }} className="br-20 p-1 flexcc mrd-2" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                      <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} alt="" />
                    </button>

                    <div className="flexcc">
                      <img className="br-20 mrd-2" src={imageAddress(hub.image, 'user', 'mini')} alt="" height={18} width={18} style={{ objectFit: 'cover' }} />
                    </div>
                    <p className="font-size-13 text-semibold" style={{ whiteSpace: 'nowrap' }}>{hub.fullname}</p>
                  </div>
                )
              })}
            </div>
          )} */}

          {hubsArray.length > 0 && (
            <div className="flexc flex-wrap">
              {hubsArray.map((hub, index) => {
                return (
                  <div key={hub._id} className="pld-1 prd-0 py-1 br-20 mrd-2 flexcb mb-1 w-100" >

                    <div className="flexc">
                      <div className="flexcc">
                        <img className="br-20 mrd-2" src={imageAddress(hub.image, 'user', 'mini')} alt="" height={30} width={30} style={{ objectFit: 'cover' }} />
                      </div>
                      <div className="d-flex flex-column">
                        <p className="font-size-14 text-bold" style={{ whiteSpace: 'nowrap' }}>{hub.fullname}</p>
                        <p className="font-size-13  color-gray-2" style={{ whiteSpace: 'nowrap' }}>{hub.username ? `@${hub.username}` : translate("Virtual user")}</p>
                      </div>
                    </div>

                    <div className="flexc">
                      {(!Array.isArray(info.constants) || !info.constants.includes(hub._id)) ? (
                        <button onClick={(e) => { e.stopPropagation(); this.changeSelect(hub, 'hubs') }} className="br-20 p-1 flexcc " style={{ backgroundColor: '#00000020', width: 18, height: 18 }}>
                          <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 13, height: 13, }} alt="" />
                        </button>
                      ) : (
                        <div className="br-20 p-1 flexcc " style={{ width: 18, height: 18 }}>
                        </div>
                      )}
                    </div>

                  </div>
                )
              })}
            </div>
          )}



          {groupsArray.length > 0 && (
            <div className="flexc flex-wrap">
              {groupsArray.map((group, index) => {
                return (
                  <div key={group._id} className="pld-1 prd-0 py-1 br-20 mrd-2 flexcb mb-1 w-100" >


                    <div className="flexc">

                      <div className="flexcc">
                        <img className="br-20 mrd-2" src={imageAddress(group.image, 'group', 'mini')} alt="" height={30} width={30} style={{ objectFit: 'cover' }} />
                      </div>
                      <div className="d-flex flex-column">
                        <p className="font-size-14 text-bold" style={{ whiteSpace: 'nowrap' }}>{group.name}</p>
                        <p className="font-size-13  color-gray-2" style={{ whiteSpace: 'nowrap' }}>{translate("Group")}</p>
                      </div>
                    </div>


                    <div className="flexc">
                      {(!Array.isArray(info.constants) || !info.constants.includes(group._id)) ? (
                        <button onClick={(e) => { e.stopPropagation(); this.changeSelect(group, 'groups') }} className="br-20 p-1 flexcc " style={{ backgroundColor: '#00000020', width: 18, height: 18 }}>
                          <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 13, height: 13, }} alt="" />
                        </button>
                      ) : (
                        <div className="br-20 p-1 flexcc " style={{ width: 18, height: 18 }}>
                        </div>
                      )}
                    </div>

                  </div>
                )
              })}
            </div>
          )}


          {condition && (
            <div className="flexc flex-wrap">

              <div className=" pld-1 prd-0 py-1 br-20 mrd-2 flexcb mb-1 w-100 flex-1" style={{ minWidth: 0 }}>

                <div className="flexc flex-1" style={{ minWidth: 0 }}>
                  <div className="flexcc mrd-2">
                    <div className="br-20 flexcc" style={{ height: 30, width: 30, backgroundColor: '#eee' }}>
                      <img src={'/assets/icons/useful/brackets-curly.svg'} alt="" height={16} width={16} style={{ objectFit: 'cover' }} />
                    </div>
                  </div>
                  <div>
                    <p className="font-size-14 text-bold" style={{ whiteSpace: 'nowrap' }}>{translate("Condition")}</p>
                    <p className="font-size-13  color-gray-2" style={{}}>{translate("Hubs which fulfill the dynamic condition")}</p>
                  </div>

                </div>

                <div className="flexc">
                  <button onClick={(e) => { e.stopPropagation(); this.changeSelect(null, 'condition') }} className="br-20 p-1 flexcc " style={{ backgroundColor: '#00000020', width: 18, height: 18 }}>
                    <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 13, height: 13, }} alt="" />
                  </button>

                </div>
              </div>
            </div>
          )}
          {/* {groupsArray.length > 0 && (
            <div className="flexc flex-wrap">
              {groupsArray.map((group, index) => {
                return (
                  <div className="pld-2 prd-4 py-1 br-20 mrd-2 flexc mb-1" style={{ backgroundColor: '#ddd' }}>

                    <button onClick={(e) => { e.stopPropagation(); this.changeSelect(group, 'groups') }} className="br-20 p-1 flexcc mrd-2" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                      <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} alt="" />
                    </button>

                    <div className="flexcc">
                      <img className="br-20 mrd-2" src={imageAddress(null, 'group', 'mini')} alt="" height={18} width={18} style={{ objectFit: 'cover' }} />
                    </div>
                    <p className="font-size-13  text-semibold" style={{ whiteSpace: 'nowrap' }}>{group.name}</p>
                  </div>

                )
              })}
            </div>
          )} */}

        </div>

        <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={20} zIndex={15} xOffset={-5} minWidth={160} maxWidth={300} rightAlign={false}>

          <div style={{ display: 'flex', width: '100%', maxWidth: 300, zIndex: 40 }}>

            <div className={'   py-1 pb-2'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderColor: '#eee', borderRadius: 6, maxHeight: 250, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.2)' }}>

              <div className="flexc  px-2 pt-2 " style={{ borderBottom: '1px solid #eee' }}>

                {/* {!this.props.currentRole && (
                  <button onClick={() => this.setState({ tab: 'roles' })} className=" pb-2 pt-0 px-2  text-center  flexc" style={{ borderBottom: this.state.tab == 'roles' ? '2px solid #007aff' : '2px solid transparent' }}>
                    <p className="font-size-14 text-bold  p-0  " >{translate('Roles')}</p>
                  </button>
                )} */}

                <button onClick={() => this.setState({ tab: 'hubs' })} className=" pb-2 pt-0 px-2  text-center  flexc" style={{ borderBottom: this.state.tab == 'hubs' ? '2px solid #007aff' : '2px solid transparent' }}>
                  <p className="font-size-14 text-bold  p-0  " >{translate('Hubs')}</p>
                </button>

                <button onClick={() => this.setState({ tab: 'groups' })} className=" pb-2 pt-0 px-2  text-center flexc " style={{ borderBottom: this.state.tab == 'groups' ? '2px solid #007aff' : '2px solid transparent' }}>
                  <p className="font-size-14 text-bold  p-0 " >{translate("ca.Groups")}</p>
                </button>

                {info.showConditions && (

                  <button onClick={() => this.setState({ tab: 'conditions' })} className=" pb-2 pt-0 px-2  text-center flexc " style={{ borderBottom: this.state.tab == 'conditions' ? '2px solid #007aff' : '2px solid transparent' }}>
                    <p className="font-size-14 text-bold  p-0 " >{translate("Conditions")}</p>
                  </button>

                )}

              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                {this.props.isLoading && (
                  <Loader
                    type="Puff"
                    color="rgba(0,122,255,1)"
                    height="40"
                    width="40"
                  />)}
              </div>


              <div className="flex-1 sc-gray2 overflow-auto w-100 pt-1 pb-5">

                {/* {this.state.tab == 'roles' && (
            <div className="">
              {this.props.allRoles?.length == 0 && (
                <div className="px-3 py-2">
                  <p className="text-small text-semibold">{translate("No role is available")}</p>
                </div>
              )}
              {this.props.allRoles?.map((role, index) => {

                let selected = (this.state.selecteds[role._id] && this.state.selecteds[role._id].removed != true)
                let disabled = this.state.selecteds[role._id]?.disabled

                return (

                  <div key={index} onClick={() => this.changeSelect(role, 'role')} className="flexcb backHover pld-4 prd-4 pb-1 pt-1 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>

                    <button className="mb-1 mt-1 w-100 text-start">
                      <p className="text-semibold text-normal">{role.name}</p>
                    </button>

                  </div>
                )
              })}
            </div>
          )} */}

                {this.state.tab == 'hubs' && (
                  <div className="">
                    {this.state.hubs?.length == 0 && (
                      <p>{translate("No user is available")}</p>
                    )}

                    {this.state.hubs && (
                      <>
                        <div className=" mb-2 mt-1 px-2">
                          <div className="w-100 mb-0 px-3  py-1 br-30" style={{ backgroundColor: '#f2f2f2', }}>
                            <input autoFocus={true} onChange={(e) => this.search(e.target.value)} placeholder={translate("Search hubs")} className="w-100 text-semibold" style={{ height: 30, fontSize: 14, background: 'transparent', borderRadius: 6, border: '0px solid #eee' }} />
                          </div>
                        </div>
                        {this.state.hubs?.map((item, index) => {

                          let selected = (this.state.selecteds?.hubs[item._id] && this.state.selecteds?.hubs[item._id].removed != true)
                          let disabled = this.state.selecteds?.hubs[item._id]?.disabled

                          return (

                            <div key={index} onClick={() => this.changeSelect(item, 'hubs')} className="flexcb backHover pld-4 prd-4 pb-1 pt-1 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>
                              <div className="flexc">
                                <div className="flexcc">
                                  <img src={imageAddress(item.image, 'profile', 'thumb')} width="36px" style={{ borderRadius: 50, height: 36, objectFit: 'cover' }} alt="" />
                                </div>
                                <div className="px-2">
                                  <p className="text-small text-semibold  ">{item.fullname}</p>

                                  {item.username ? (
                                    <p className="text-smaller " style={{ color: '#789' }}>@{item.username}</p>

                                  ) : (
                                    <p className="text-smaller " style={{ color: '#789' }}>{translate('ca.Virtual User')}</p>

                                  )}
                                </div>
                              </div>
                              <div className="flexc">
                                {item.relation?.licensed && (
                                  <div className='flexc br-20 ' style={{}}>
                                    <img src="/assets/icons/applets/general/diamond-award.png" height={20} alt="" />
                                  </div>
                                )}

                                {item.relation && (
                                  <div className='flexc br-20 mld-2 opacity-5' style={{}}>
                                    <img src="/assets/icons/useful/link (4).png" height={16} alt="" />
                                  </div>
                                )}

                              </div>

                            </div>
                          )
                        })}
                      </>
                    )}
                  </div>
                )}



                {this.state.tab == 'groups' && (

                  <>
                    <div className=" mb-1 mt-1 px-2">
                      <div className="w-100 mb-0 px-3  py-1 br-30" style={{ backgroundColor: '#f2f2f2', }}>
                        <input value={this.state.groupSearchtitle} onChange={(e) => this.searchGroups(e.target.value)} placeholder={translate("Search groups")} className="w-100 text-semibold" style={{ height: 30, fontSize: 14, background: 'transparent', borderRadius: 6, border: '0px solid #eee' }} />
                      </div>
                    </div>

                    <div className="">
                      {this.state.groups?.length == 0 && (
                        <p className="text-semibold py-2 text-center">{translate("No group is available")}</p>
                      )}


                      {this.renderGroupOptions(this.state.groups, parentGroupsData, 0)}


                    </div>

                  </>
                )}

{/* {console.log(this.props.variables)} */}
                {this.state.tab == 'conditions' && (
                  <div className="px-2 py-2">
                    <p className="text-smaller mb-1 px-1">{translate("All hubs who fulfills the following conditions will be effected.")}</p>
                    <HubConditionBuilder data={this.state.selecteds?.condition} header={{ key: '', information: {} }} changeValue={this.changeConditionValue} params={this.props.params} variables={this.props.variables} />
                  </div>
                )}


              </div>
            </div>
          </div>

        </FixedView>

      </div >

    );
  }
}



export default HubsAndGroupsInput;
